'use client';

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../contexts/ApiContext';
import { queryKeys } from '../../../lib/queryClient';
import type { RecentReceiver, RecentReceiversResponse } from '../../../services/generated/Api';

export type { RecentReceiver, RecentReceiversResponse as AchievementRecentReceiversResponse };

export function useAchievementRecentReceivers(key?: string) {
  const api = useApiClient();
  return useQuery({
    queryKey: queryKeys.achievementsRecentReceivers(key),
    queryFn: () => api.api.achievementsControllerGetRecentReceivers({ key: key as string, limit: 10 }),
    enabled: !!key,
    staleTime: 5 * 60 * 1000,
  });
}
